// src/VoiceIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var VoiceIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.0447 6.79288C10.43 6.79288 10.7424 7.10524 10.7424 7.49055V13.7042C10.7424 14.0895 10.43 14.4019 10.0447 14.4019C9.65936 14.4019 9.347 14.0895 9.347 13.7042V7.49055C9.347 7.10524 9.65936 6.79288 10.0447 6.79288Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.39352 8.4117C5.77883 8.4117 6.09119 8.72406 6.09119 9.10938V12.0863C6.09109 12.4715 5.77877 12.784 5.39352 12.784C5.00826 12.784 4.69594 12.4715 4.69584 12.0863V9.10938C4.69584 8.72406 5.0082 8.4117 5.39352 8.4117Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6958 8.4117C15.0812 8.4117 15.3935 8.72406 15.3935 9.10938V12.0863C15.3934 12.4715 15.0811 12.784 14.6958 12.784C14.3106 12.784 13.9983 12.4715 13.9982 12.0863V9.10938C13.9982 8.72406 14.3105 8.4117 14.6958 8.4117Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.8354 0.28125C15.2298 0.28125 17.0873 0.755908 18.3287 1.99727C19.57 3.23864 20.0447 5.09616 20.0447 7.49055V13.0719C20.0447 15.4663 19.57 17.3239 18.3287 18.5652C17.0873 19.8066 15.2298 20.2812 12.8354 20.2812H7.25398C4.85959 20.2812 3.00207 19.8066 1.7607 18.5652C0.519336 17.3239 0.0446777 15.4663 0.0446777 13.0719V7.49055C0.0446777 5.09616 0.519336 3.23864 1.7607 1.99727C3.00207 0.755908 4.85959 0.28125 7.25398 0.28125H12.8354ZM7.25398 1.6766C4.99721 1.6766 3.59891 2.13217 2.74726 2.98383C1.8956 3.83549 1.44003 5.23378 1.44003 7.49055V13.0719C1.44003 15.3287 1.8956 16.727 2.74726 17.5787C3.59891 18.4303 4.99721 18.8859 7.25398 18.8859H12.8354C15.0921 18.8859 16.4904 18.4303 17.3421 17.5787C18.1938 16.727 18.6493 15.3287 18.6493 13.0719V7.49055C18.6493 5.23378 18.1938 3.83549 17.3421 2.98383C16.4904 2.13217 15.0921 1.6766 12.8354 1.6766H7.25398Z",
          fill: "currentColor"
        }
      )
    ]
  }
);

export {
  VoiceIcon
};
